import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderUserMenu} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {useUserSelector} from '../../../../app/store/user'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {currentUser} = useAuth()
  const {user, myCompany, isSuperAdmin, isUser} = useUserSelector()
  return (
    <div className='app-navbar flex-shrink-0'>
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx(
            'cursor-pointer symbol d-flex align-middle align-items-center',
            userAvatarClass
          )}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          {/* <img src={toAbsoluteUrl('/media/avatars/300-3.jpg')} alt='' /> */}
          <div className='d-flex flex-column p-2'>
            <div className='fw-bolder d-flex align-items-center justify-content-end fs-5'>
              {currentUser?.firstName} {currentUser?.lastName}
            </div>
            <div className='fw-bold d-flex text-muted justify-content-end fs-8'>
              {`${isUser ? `${user?.companyGroup?.name} / ${myCompany?.company.name}` : ''} `}
              {`${isSuperAdmin || user?.isCompanyGroupAdmin ? `${user?.companyGroup?.name}` : ''} `}
            </div>
          </div>
          <KTIcon iconName='gear' className={btnIconClass} />
        </div>
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}
    </div>
  )
}

export {Navbar}
